<template>
  <div
    :class="[{'vs-sidebar-item-active':activeLink}, {'disabled-item pointer-events-none': isDisabled}]"
    class="vs-sidebar--item"
    v-if="canSee"
  >
    <router-link v-if="resolvedTo" :to="resolvedTo" :class="[{'router-link-active': activeLink}]" :target="target" exact>
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" class="fa-fw"></vs-icon>
      <feather-icon :icon="icon" :class="{'w-3 h-3': iconSmall}" v-else></feather-icon>
      <slot></slot>
    </router-link>
    <a v-else :target="target" :href="href">
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" class="fa-fw"></vs-icon>
      <feather-icon :icon="icon" :class="{'w-3 h-3': iconSmall}" v-else></feather-icon>
      <slot></slot>
    </a>
  </div>
</template>

<script>
import { demoPrefixedPath } from "@/demo/link";

export default {
  name: "VxSidebarItem",
  props: {
    icon: {
      default: "",
      type: String
    },
    iconSmall: {
      default: false,
      type: Boolean
    },
    iconPack: {
      default: "material-icons",
      type: String
    },
    href: {
      default: "#",
      type: String
    },
    to: {
      default: null,
      type: String
    },
    index: {
      default: null,
      type: [String, Number]
    },
    featherIcon: {
      default: true,
      type: Boolean
    },
    target: {
      default: "_self",
      type: String
    },
    isDisabled: {
      default: false,
      type: Boolean
    },
    demoLinkPrefix: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      activeLink: false
    };
  },
  watch: {
    $route() {
      this.CheckIsActive();
    },
    resolvedTo() {
      this.CheckIsActive();
    }
  },
  methods: {
    CheckIsActive() {
      const t = this.resolvedTo;
      if (t) {
        const p = this.$route.path.split("?")[0];
        this.activeLink = p === t || p.startsWith(t + "/");
      } else {
        this.activeLink = false;
      }
    }
  },
  computed: {
    canSee() {
      return true;
    },
    resolvedTo() {
      if (!this.to) return null;
      return demoPrefixedPath(this.to, this.demoLinkPrefix);
    }
  },
  mounted() {
    this.CheckIsActive();
  },
  updated() {
    this.CheckIsActive();
  }
};
</script>
